import IconBase from './components/icons/IconBase.vue'
import IconTurkey from './components/icons/IconTurkeyFlag.vue'
import IconEngland from './components/icons/IconEnglandFlag.vue'
import IconRussia from './components/icons/IconRussiaFlag.vue'
import IconTaiwan from './components/icons/IconTaiwanFlag.vue'
import Vue from 'vue'


Vue.component('icon-base', IconBase)
Vue.component('icon-turkey-flag', IconTurkey)
Vue.component('icon-england-flag', IconEngland)
Vue.component('icon-russia-flag', IconRussia)
Vue.component('icon-taiwan-flag', IconTaiwan)